// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"YehImage_imgWrapper__RMn2U","imgProps":"YehImage_imgProps__3XPjs"};